export interface SalesInvoicesCreated {
  id: string;
  invoiceNo: number;
  dateInvoiced: Date;
  createdBy: string;
  customerKey: string;
  customerName: string;
  currencyCode: string;
  despatchNoteNo: number;
  invoiceItemTotal: number;
  invoiceDeliveryTotal: number;
  invoiceExtraTotal: number;
  invoiceNettTotal: number;
  invoiceTaxTotal: number;
  invoiceOverallTotal: number;
}
